import React, { Component } from 'react';
import CountUp from 'react-countup'

class TotalHits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myValue: 42 // Replace this with your value from the backend or any other source
    };
  }

  render() {
    return (
      
        <div className="totalhitsbox">
          <p>Total Hits</p>
          <div className="totalhitsvalue-container"><CountUp start={0} end={this.props.value} duration={10} suffix="+"></CountUp></div>
        </div>
      
    );
  }
}

export default TotalHits;
